module.exports = __webpack_public_path__ + "img/farewell_2.f710b830.jpg";